export default __webpack_public_path__ + "static/media/at2_success_icon.a1fe2589.svg";